<template>
    <Fragment>
        <AppSummary
            title_summary="Vendedor"
            :collapses="collapses"
            v-if="showSellerFieldAtCheckout"
        >
            <template #employee-shipping-collapse>
                <v-select
                    v-model="employee"
                    class="input-select"
                    placeholder="Nenhum vendedor selecionado"
                    :options="paginated"
                    :filterable="false"
                    @open="onOpen"
                    @close="onClose"
                    @search="query => (search = query)"
                >
                    <template #no-options>
                        Nenhum vendedor encontrado.
                    </template>
                    <template #list-footer>
                        <li v-show="hasNextPage" ref="load" class="loader">
                            Carregando...
                        </li>
                    </template>
                </v-select>
            </template>
        </AppSummary>
    </Fragment>
</template>

<script>
import AppSummary from "../AppSummary.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { Fragment } from "vue-fragment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    name: "EmployeeCheckout",
    components: {
        AppSummary,
        Fragment,
        vSelect
    },
    data() {
        return {
            observer: null,
            limit: 10,
            search: "",
            total: 0,
            employee: null,
            close: true,
            collapses: [
                {
                    title: "Teve ajuda de algum vendedor? Se sim, qual?",
                    id: "employee-shipping-collapse",
                    collapsed: true
                }
            ]
        };
    },
    mounted() {
        this.observer = new IntersectionObserver(this.infiniteScroll);
        this.getEmployee();
    },
    methods: {
        ...mapActions("employee", [
            "ActionGetEmployees",
            "ActionGetEmployee",
            "ActionSetEmployees",
            "ActionSetEmployee",
            "setEmployee"
        ]),
        getEmployee() {
            this.ActionGetEmployee()
                .then(response => {
                    this.employee = response.data;
                })
                .catch(error => alert(error));
        },
        async onOpen() {
            this.close = false;
            await this.getEmployees();
            if (this.hasNextPage) {
                await this.$nextTick();
                this.observer.observe(this.$refs.load);
            }
        },
        onClose() {
            this.close = true;
            this.observer.disconnect();
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 10;
                await this.getEmployees();
                await this.$nextTick();
                ul.scrollTop = scrollTop;
            }
        },
        async getEmployees() {
            let filters = this.getFilters();
            await this.ActionGetEmployees(filters)
                .then(response => {
                    this.total = response.data.total;
                    this.ActionSetEmployees(response.data.data);
                })
                .catch(error => alert(error));
        },
        getFilters() {
            return {
                search: this.search,
                limit: this.limit
            };
        }
    },
    watch: {
        search() {
            if (!this.close) {
                this.getEmployees();
            }
        },
        employee(employee) {
            this.setEmployee(employee);
            this.ActionSetEmployee(employee);
        }
    },
    computed: {
        ...mapState("employee", ["employees"]),
        ...mapState("clients", ["clientLogged", "client"]),
        ...mapGetters("company", ["showSellerFieldAtCheckout"]),
        paginated() {
            return this.employees;
        },
        hasNextPage() {
            return this.paginated.length < this.total;
        }
    }
};
</script>
